
































import Vue from 'vue';
import WxTemplate from '../../../models/WxTemplate';
import scheduleRuleVuex from '../../../vuex/common';
import scheduleClient from '../../../apis';

const wxTemplate: WxTemplate | undefined = undefined;
const tplColors: { [key: string]: string } = {};
const tplValues: { [key: string]: string } = {};
const tplPropConfigs: { [key: string]: any[] } = {};

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  props: {
    templateId: {
      type: String,
      default: null,
    },
    wxTpl: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      wxTemplate,
      templateContent: '',
      templateContentDisplay: '',
      tplColors,
      tplValues,
      tplPropConfigs,
      defaultColor: '#000',
    };
  },
  computed: {
    tranTextProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        if (p.builtIn) {
          p.fieldName = '\\${' + p.fieldName + '}';
        } else {
          p.fieldName = '\\${privateProps.' + p.fieldName + '}';
        }
        return p;
      });
    },
  },
  methods: {
    loadTemplates() {
      scheduleClient.getTemplates().success((r) => {
        const wxTemplates: WxTemplate[] = [];
        const templateList = r.templateList;
        for (const tpl of templateList) {
          wxTemplates.push(new WxTemplate(tpl));
        }
        this.$store.commit('UPDATE_WX_TEMPLATES', wxTemplates);
        this.setWxTemplate();
      });
    },
    setWxTemplate() {
      if (this.wxTemplates.length > 0) {
        this.wxTemplate = this.wxTemplates.find(t => {
          return t.templateId === this.templateId;
        });
        this.templateContent = (this.wxTemplate as WxTemplate).content.replace(/\n/g, '<br />').replace(/\.DATA\}/g, '}');
        this.templateContentDisplay = JSON.parse(JSON.stringify(this.templateContent));
        this.$data.tplValues = {};
        for (const field of this.wxTplFields()) {
          this.$data.tplValues[field] = null;
          this.$data.tplColors[field] = this.defaultColor;
        }
        this.setTplValueAndColors();
        this.updateContent();
      }
    },
    updateContent() {
      let content = JSON.parse(JSON.stringify(this.templateContent));
      let counter = 0;
      const keys = Object.keys(this.tplValues);
      keys.forEach((i) => {
        const regx = new RegExp(`\{\{${i}\}\}`, 'g');
        const string = (!this.tplValues[i] || this.tplValues[i] === '') ? `{{${i}}}` : this.tplValues[i];
        let color = this.tplColors[i];
        if (counter === keys.length - 1) {
          color = '#999999';
        }
        content = content.replace(regx, `<span style="color:${color};">${string}</span>`);
        counter++;
      });
      if (this.wxTpl.remark && this.wxTpl.remark.open) {
        content = content + '<br><input type="checkbox" checked disabled> 给点击过模板消息的用户打标签（预览时除外）<br>' + `<span style="color:#999999;">${this.wxTpl.remark.remark}</span>`;
      }
      this.templateContentDisplay = content;
    },
    transValueText(value: string) {
      this.tranTextProps.forEach((p: any) => {
        value = value.replace(new RegExp(p.fieldName, 'g'), '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>');
        value = value.replace(new RegExp('\\${custom.current}', 'g'), '<drip-prop contenteditable="false">#系统时间</drip-prop>');
      });
      return value;
    },
    setTplValueAndColors() {
      if (this.wxTpl) {
        const params = JSON.parse(JSON.stringify(this.wxTpl.params));
        const keys = Object.keys(this.tplValues);
        keys.forEach((i) => {
          this.tplColors[i] = params[i]['color'];
          this.tplValues[i] = this.transValueText(params[i]['value']);
          this.tplPropConfigs[i] = params[i]['propConfigs'];
        });
      }
    },
    wxTplFields(): string[] {
      if (this.wxTemplate) {
        return this.wxTemplate!.content.match(/{{([0-9a-zA-Z]*.DATA)}}/gi)!.map((r) => {
          return r.replace(/{{/g, '').replace(/.DATA}}/, '');
        });
      } else {
        return [];
      }
    },
  },
  mounted() {
    if (this.wxTemplates.length === 0) {
      this.loadTemplates();
    } else {
      this.setWxTemplate();
    }
  },
});
